<template lang='pug'>
v-card(style=" background-color: #EEEEEE; padding-left: 20px")
  v-card-title(style='display: block')
    v-row
      v-col(cols='auto')
        h2 {{item._source.fullName}}
        h4 Login: {{item._source.login}}
        h4 E-mail: {{item._source.email}}
        md-button.margin-left.margin-top( @click='generateFile("print")' :disabled='loadingGeneration.print || dialogsGeneration' class='md-sm md-facebook')
          template(v-if='!loadingGeneration.print')
            md-icon(style='font-size: 24px !important;') print
            md-tooltip(md-direction="bottom")
              | {{$t('operatorTimeline.printOut')}}
          template(v-else)
            v-progress-circular(
              size='17',
              width='2',
              style='transition: 0.1s;'
              color='#fff'
              indeterminate)
        md-button.margin-left.margin-top(@click='generateFile("csv")' :disabled='loadingGeneration.csv || dialogsGeneration' class='md-sm md-facebook')
          template(v-if='!loadingGeneration.csv')
            md-icon(style='font-size: 24px !important;') table_view
            md-tooltip(md-direction="bottom")
              | {{$t('operatorTimeline.generateSpreadsheet')}}
          template(v-else)
            v-progress-circular(
              size='17',
              width='2',
              style='transition: 0.1s;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("pdf")' :disabled='loadingGeneration.pdf || dialogsGeneration' class='md-sm md-facebook' style='margin-right: 0px;')
          template(v-if='!loadingGeneration.pdf')
            md-icon(style='font-size: 24px !important;') picture_as_pdf
            md-tooltip(md-direction="bottom")
              | {{$t('operatorTimeline.exportPdf')}}
          template(v-else)
            v-progress-circular(
              size='17',
              width='2',
              style='transition: 0.1s;'
              color='#fff'
              indeterminate)
        VueJsonToCsv#timeline-csv-component(:json-data='csvData' :csv-title="csvName" :labels='formatedCVSLabels' style='opacity: 0; pointer-events: none;')
      v-col
        v-btn(
          @click='closeTimelineDialog'
          icon
          large
          style='float: right'
        )
          v-icon(large) mdi-close
  PerfectScrollbar(v-if='timelineLoader')
    v-container(style="max-width: 800px; display: block")
      v-timeline(
          dense
          clipped
        )
          v-timeline-item(
            fill-dot
            class="white--text mb-12"
            large
          )
          v-timeline-item(
            v-for=' i in 5'
            :key='i'
            class="mb-4"
            color="#ccc"
            icon-color="grey lighten-2"
            small
          )
            v-skeleton-loader(
              style='width: 30%; background-color: #EEEEEE;'
              type="text@1")
            v-skeleton-loader(
              style='width: 80%; background-color: #EEEEEE;'
              type="text@1")
            v-skeleton-loader(
              style='width: 80%; background-color: #EEEEEE;'
              type="text@1")
            v-skeleton-loader(
              style='width: 80%; background-color: #EEEEEE;'
              type="text@1")
  PerfectScrollbar(v-else)
    v-container(style="max-width: 800px; display: block; justify-content: center")
      v-timeline(
        dense
        clipped
      )
        v-timeline-item(
          fill-dot
          class="white--text mb-12"
          color="#ff9800"
          large
        )
          template(v-slot:icon)
            //- span(style='color: #fff') {{item._source.fullName[0]}}
          h1(style='color: #ccc') {{item._source.firstName}} &nbsp; {{item._source.lastName}}
        v-timeline-item(
          class="mb-6"
          hide-dot
        )
          span {{formatDate(date)}}
        v-timeline-item(
          v-for='(event, i) in operatorTimelineInfo.events'
          :key='i'
          class="mb-4"
          :color="event.event === $t('operatorTimeline.attendance') ? '#9c27b0' : '#ccc'"
          icon-color="grey lighten-2"
          small
        )
          v-row(justify="space-between")
            v-col(cols="9")
              h3(v-if='event.event === "Atendimento"' style='margin:0; font-weight: 500') {{formateLabels(event, 0)}}
              template(v-else) {{formateLabels(event, 0)}}
                br(v-if='event.status')
              h5(v-if='event.status' style='display: inline; font-weight: 500') Status:&nbsp;
                v-chip(
                  v-if='event.status'
                  class="white--text ml-0"
                  :color="statusColor(event.status)"
                  label
                  small
                  style='color: #fff'
                )
                  | {{formateLabels(event, 1)}}
                span(v-if='event.new_status && event.new_status !== event.status')
                  | &nbsp; {{$t('operatorTimeline.for')}} &nbsp;
                  v-chip(
                    class="white--text ml-0"
                    :color="statusColor(event.new_status)"
                    label
                    small
                    style='color: #fff'
                  )
                    | {{formateLabels(event, 2)}}
                br
              div(v-if='event.event !== "logout" && event.new_condition')
                h5(style='display: inline; font-weight: 500') {{$t('operatorTimeline.state:')}} &nbsp;
                span(style='display: inline;') {{formateLabels(event, 3)}}
              div(v-if='event.event === "Atendimento"')
                h5(style='display: inline; font-weight: 500') {{$t('operatorTimeline.conversationId')}} &nbsp;
                span {{formateLabels(event, 4)}}
                v-btn(small @click='openConversationDialog(event.conversation_id)' style='display: block')
                  | {{$t('operatorTimeline.seeDetails')}}
            v-col(
              class="text-right"
              cols="2"
            )
              | {{formateLabels(event, 5)}}
    v-dialog(v-model='conversationDialog' max-width='700px' scrollable persistent)
      ChatConversation(
        :chatLoader='chatLoader'
        :chatData='chatData'
        :chatInfo='chatInfo'
        :channelConfig='channelConfig'
        :key='chatInfo._id'
        @close='closeConversationDialog'
      )
</template>

<script>
import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import VueJsonToCsv from 'vue-json-to-csv'
import ChatConversation from '@/components/ChatConversation'
import { mapFields } from 'vuex-map-fields'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { selectedLocale } from '@/plugins/i18n'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    operatorTimelineInfo: {
      type: Object,
      required: true
    },
    date: {
      required: true
    },
    timelineLoader: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VueJsonToCsv,
    ChatConversation,
    PerfectScrollbar
  },
  data () {
    return {
      loadingGeneration: {
        pdf: false,
        csv: false,
        print: false
      },
      dialogsGeneration: false,
      conversationDialog: false,
      chatData: {},
      chatLoader: false,
      chatInfo: {},
      channelConfig: null,
      progressGeneration: 0,
      endpoint: '',
      filter: {},
      totalTimelineItems: 0,
      csvData: [],
      csvName: null,
      labels: [this.$t('operatorTimeline.event'), 'Status', this.$t('operatorTimeline.newStatus'), this.$t('operatorTimeline.state'), this.$t('operatorTimeline.conversationId'), this.$t('operatorTimeline.time')]
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    formatedCVSLabels () {
      let csvObjLabels = {}
      this.labels.forEach((label) => {
        csvObjLabels[this.strToSlug(label)] = {
          title: label
        }
      })
      return csvObjLabels
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L')
    },
    formatTime (date) {
      const dateObj = new Date(date)
      const t = `${this.leadZeros(2, dateObj.getHours())}:${this.leadZeros(2, dateObj.getMinutes())}`
      return `${t}`
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    statusColor (status) {
      if (status === 'away') {
        return '#ff9800'
      } else if (status === 'busy') {
        return '#F44336'
      } else if (status === 'available') {
        return '#43a047'
      } else {
        return '#969696'
      }
    },
    statusText (status) {
      if (status === 'away') {
        return this.$t('operatorTimeline.absent')
      } else if (status === 'busy') {
        return this.$t('operatorTimeline.occupied')
      } else if (status === 'available') {
        return this.$t('operatorTimeline.available')
      } else if (status === 'offline') {
        return 'Offline'
      } else {
        return ''
      }
    },
    stateText (state) {
      if (state === 'pending') {
        return this.$t('operatorTimeline.distributed')
      } else if (state === 'attendance') {
        return this.$t('operatorTimeline.attending')
      } else if (state === 'idle') {
        return this.$t('operatorTimeline.idle')
      } else {
        return ''
      }
    },
    formateLabels (event, i) {
      switch (i) {
        case 0:
          return event.event || ''
        case 1:
          return this.statusText(event.status)
        case 2:
          return this.statusText(event.new_status)
        case 3:
          return this.stateText(event.new_condition)
        case 4:
          return event.conversation_id || ''
        case 5:
          return this.formatTime(event.datetime)
        default:
          break
      }
    },
    async openConversationDialog (conversationId) {
      this.conversationDialog = true
      this.chatLoader = true
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId
          }
        })
        this.chatData = result.data
        this.chatInfo._id = conversationId
        this.chatInfo._source = {}
      } catch (error) {
      }
      this.chatLoader = false
    },
    closeConversationDialog () {
      this.conversationDialog = false
    },
    closeTimelineDialog () {
      this.$emit('close')
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, `${this.$t('operatorTimeline.operatorJourney')} ${this.item._source.fullName}`)

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, 'Data: ')
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.date).format('DD/MM/YYYY')
      doc.text(29, 17, `${formattedDate1}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('operatorTimeline.totalOfEvents'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    strToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
    async generateFile (type) {
      this.totalTimelineItems = this.operatorTimelineInfo.events.length
      this.filter = this.date
      this.endpoint = `${process.env.VUE_APP_REPORTS_BACKEND}/operators/${this.item._id}/events`
      const totalItems = JSON.parse(JSON.stringify(this.totalTimelineItems))
      this.progressGeneration = 0
      if (totalItems > 1000) {
        this.dialogsGeneration = true
      }
      this.loadingGeneration[type] = true
      let filterClone = JSON.parse(JSON.stringify(this.filter))
      const perPage = 1000
      if (filterClone.perPage) {
        filterClone.perPage = perPage
      }
      try {
        // eslint-disable-next-line
        const response = await this.$axios.get(this.endpoint, {
          params: filterClone
        })
        if (type === 'pdf' || type === 'print') {
          let bodyLabels = []
          let labelLine = []
          this.operatorTimelineInfo.events.forEach(event => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('operatorTimeline.canceledByUser'))
            labelLine = []
            this.labels.forEach((_, index) => {
              labelLine.push(this.formateLabels(event, index))
            })
            bodyLabels.push(labelLine)
          })
          // eslint-disable-next-line
          const doc = new jsPDF()
          let offSetY = this.createHeaderPDF(doc, this.totalTimelineItems)

          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('operatorTimeline.canceledByUser'))
          doc.autoTable({
            startY: offSetY,
            head: [this.labels],
            body: bodyLabels
          })
          // checamos se queremos só o pdf ou também queremos imprimir
          if (type === 'pdf') {
            let timestamp = Date.now()
            doc.save(`${timestamp}_jornada_do_operador_${this.item._source.firstName}.pdf`)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        } else if (type === 'csv') {
          let bodyLabels = []
          let lineObject = {}
          this.operatorTimelineInfo.events.forEach(event => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('operatorTimeline.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formateLabels(event, index)
            })
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          this.csvData = bodyLabels
          let timestamp = Date.now()
          this.csvName = `${timestamp}_jornada_do_operador_${this.item._source.firstName}`
          this.$nextTick(() => {
            document.querySelector('#timeline-csv-component').click()
          })
        }
      } catch (error) {
        if (error.message === this.$t('operatorTimeline.canceledByUser')) {
          Swal.fire({
            icon: 'error',
            title: this.$t('operatorTimeline.cancel')
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: this.$t('operatorTimeline.errorGeneratingFile')
          })
        }
      } finally {
        this.dialogsGeneration = false
        this.loadingGeneration[type] = false
        setTimeout(() => {
          this.progressGeneration = 0
        }, 100)
      }
    }
  },
  mounted () {
    if (typeof this.assistantId !== typeof null) {
      let generalConfig = null
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(response => {
          generalConfig = response.data
          // importing channel config
          if (generalConfig.webclientChannels.length > 0) {
            this.channelConfig = generalConfig.webclientChannels[0]
          } else if (generalConfig.whatsappChannels.length > 0) {
            this.channelConfig = generalConfig.whatsappChannels[0]
          } else if (generalConfig.teamsChannels.length > 0) {
            this.channelConfig = generalConfig.teamsChannels[0]
          } else if (generalConfig.telegramChannels.length > 0) {
            this.channelConfig = generalConfig.telegramChannels[0]
          } else {
            this.channelConfig = null
          }
        })
    }
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
    })
  }
}
</script>

<style>
.v-timeline::before {
  left: 6.6%;
}

  @media (max-width: 850px) {
    .v-timeline:before {
      margin: 5.5px;
    }
  }
</style>
